import {
  Card as MaterialCard,
  CardActions as MaterialCardActions,
  CardActionsProps as CardActionsProps,
  CardContent as MaterialCardContent,
  CardContentProps as CardContentProps,
  CardHeader as MaterialCardHeader,
  CardHeaderProps as CardHeaderProps,
  CardMedia as MaterialCardMedia,
  CardMediaProps as CardMediaProps,
  CardProps as MaterialCardProps,
} from '@mui/material';
import React from 'react';

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    elevation: false;
    outlined: false;

    horizontalLarge: true;

    'content:recommendation': true;
    'content:heroThirdRight': true;
    'content:heroThirdLeft': true;
    'content:heroHalfRight': true;
    'content:heroHalfLeft': true;
    'content:oneHalf': true;
    'content:oneThird': true;
    'content:small': true;
    'content:jobStandard': true;
    'content:jobPremium': true;
    'content:list': true;

    productExtraLargeMediaRight: true;
    productExtraLargeMediaLeft: true;
    productLargeMediaRight: true;
    productLargeMediaLeft: true;
    productMedium: true;

    'service:heroMediaLeft': true;
    'service:heroMediaRight': true;
    'service:heroMediaSquare': true;
    'service:cardHalf': true;
    'service:campaign': true;
    'service:list': true;

    seminar: true;
    campaign: true;
    wallStart: true;
    wall: true;
    info: true;

    'product:heroThirdLeft': true;
    'product:heroThirdRight': true;
    'product:half': true;
    'product:halfSquare': true;
    'product:third': true;
    'product:thirdSquare': true;
    'product:fourth': true;
  }
}

export type CardProps = MaterialCardProps;

/**
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 * @see [https://styleguide.sparkasse.de/document/69#/ui-komponenten/card]
 */
export const Card: React.FC<MaterialCardProps> = ({
  square = true,
  elevation = 0,
  onClick,
  sx,
  ...props
}: MaterialCardProps) => {
  return (
    <MaterialCard
      square={square}
      elevation={elevation}
      sx={{ cursor: onClick ? 'pointer' : 'default', ...sx }}
      onClick={onClick}
      {...props}
    />
  );
};

export const CardMedia: React.FC<CardMediaProps> = MaterialCardMedia;
CardMedia.displayName = 'CardMedia';

export const CardContent: React.FC<CardContentProps> = MaterialCardContent;
CardContent.displayName = 'CardContent';

export const CardActions: React.FC<CardActionsProps> = MaterialCardActions;
CardActions.displayName = 'CardActions';

export const CardHeadlineHeader: React.FC<CardHeaderProps> = ({ children, ...props }) => (
  <MaterialCardHeader className="MuiCardHeader-headline" title={children} {...props} />
);
export const CardTagHeader: React.FC<CardHeaderProps> = ({ children, ...props }) => (
  <MaterialCardHeader className="MuiCardHeader-tag" title={children} {...props} />
);
